/*
 * KONTRAST 2026 — Dissuasion de copie des images
 *
 * Bloque le menu contextuel (clic droit) et le glisser-déposer
 * sur les médias uniquement. Le clic droit reste disponible
 * partout ailleurs, pour ne pas dégrader la navigation.
 *
 * Désactivé dans l'éditeur de thème pour rester utilisable.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var MEDIA_SELECTOR = [
    'img',
    'picture',
    'video',
    '.media',
    '[class*="__media"]',
    '[class*="__img"]',
    '[class*="__image"]',
    '.product-card__media',
    '.slideshow__media',
    '.about__img',
    '.featured-collection__img_inner'
  ].join(',');

  function isMedia(el) {
    if (!el || typeof el.closest !== 'function') return false;
    try {
      return !!el.closest(MEDIA_SELECTOR);
    } catch (err) {
      return false;
    }
  }

  document.addEventListener(
    'contextmenu',
    function (e) {
      if (isMedia(e.target)) e.preventDefault();
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (e) {
      if (isMedia(e.target)) e.preventDefault();
    },
    true
  );
})();
